import { DEMAND_FETCHING, DEMAND_FAILED, DEMAND_SUCCESS } from "./types";

import DemandService from "../services/demand.service";

export const getAllDemand = () => async (dispatch) => {
  try {
    dispatch({
      type: DEMAND_FETCHING,
    });
    const res = await DemandService.getAllDemand();
    if (res) {
      dispatch({
        type: DEMAND_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: DEMAND_FAILED,
    });
    console.log(err);
  }
};
